var render = function render(){
  var _vm$form, _vm$form$data, _vm$form$data$success, _vm$form$data$success2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "my-15"
  }, [_vm._v("Clés de réussite")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs pb-10 px-10 text-justify flex flex-col space-y-3"
  }, [_c('p', [_vm._v("\n      La compensation d'un handicap est la réponse individuelle apportée à la\n      personne en situation de handicap pour faire face aux \"conséquences de\n      son handicap quels que soient l'origine et la nature de sa déficience,\n      son âge ou son mode de vie\".\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Pour valider cette compensation, il est important de définir les\n      principaux éléments (clefs de réussites) qui favoriseraient la prise en\n      compte de votre (vos) situation(s) de handicap.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Et donc réduiraient la (les) conséquence(s) de votre (vos) handicap(s)\n      au travail ou en formation.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Ex : J'ai des problèmes de dos qui m'empêchent d'avoir une posture\n      assise et debout en continue. Une de vos clefs de réussite serait un\n      aménagement de votre bureau de travail. Et donc de vous proposer un\n      bureau réglable en hauteur (bureau assis-debout).\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "flex space-x-2 items-center"
  }, [_c('icon', {
    attrs: {
      "name": "alert-triangle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n        Il est nécessaire de mettre en avant sur votre CV uniquement les\n        éléments qui sont essentiels. Pour ce faire, si tout vous convient\n        dans les catégories proposées ci-dessous cocher la case \"TOUT\" et rien\n        n'apparaitra sur le CV.\n      ")])], 1)]), _vm._v(" "), _vm.isErrorMaxLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8 mx-20"
  }, [_vm._v("\n    ATTENTION : Il y a trop de clés de réussite. Cela risque d'altérer la\n    présentation de votre CV.\n  ")]) : _vm._e(), _vm._v(" "), !((_vm$form = _vm.form) !== null && _vm$form !== void 0 && (_vm$form$data = _vm$form.data) !== null && _vm$form$data !== void 0 && (_vm$form$data$success = _vm$form$data.success) !== null && _vm$form$data$success !== void 0 && (_vm$form$data$success2 = _vm$form$data$success.value) !== null && _vm$form$data$success2 !== void 0 && _vm$form$data$success2.all) ? _c('div', _vm._l(_vm.constants.cvdatas.listSuccess, function (libelleSucces, ks) {
    return _c('div', {
      key: 'libelleSucces' + ks,
      staticClass: "p-0 odd:bg-gray-200 odd:bg-opacity-50"
    }, [_c('accordion-item', {
      attrs: {
        "is-accordion-displayed": _vm.typeSuccessToDisplay === ks
      },
      on: {
        "clickOnItem": function ($event) {
          return _vm.displayTypeSuccess(ks);
        }
      },
      scopedSlots: _vm._u([{
        key: "description",
        fn: function () {
          return [_c('div', {
            staticClass: "col-span-2 justify-self-center handle"
          }, [_c('icon', {
            staticClass: "text-pink-600 h-3 transform transition-all duration-200",
            class: {
              'rotate-90': _vm.typeSuccessToDisplay === ks
            },
            attrs: {
              "name": "chevron-right"
            }
          })], 1), _vm._v(" "), _c('div', {
            staticClass: "col-span-10 text-base font-normal"
          }, [_vm._v("\n            " + _vm._s(libelleSucces) + "\n          ")])];
        },
        proxy: true
      }, {
        key: "content",
        fn: function () {
          return [_c('div', {
            staticClass: "grid grid-cols-3 gap-3 mb-3"
          }, _vm._l(_vm.constants.cvdatas.success[ks], function (typePlace, ktp) {
            return _c('div', {
              key: 'typePlace' + ktp,
              staticClass: "col-span-full md:col-span-1"
            }, [ks != 'office' ? _c('multiple-select', {
              attrs: {
                "datas": typePlace.reduce(function (acc, tp) {
                  return [].concat(acc, [{
                    value: tp[0].toUpperCase() + tp.slice(1).toLowerCase()
                  }]);
                }, []),
                "name": ktp,
                "libelle": ktp,
                "value": (_vm.form.data.success.value[ks] || {})[ktp] || [],
                "error": true,
                "has-item-all": true
              },
              on: {
                "input": function (newValue) {
                  _vm.displaySuccess(ks, ktp, newValue);
                },
                "loseFocus": function ($event) {
                  return _vm.saveDatas();
                }
              }
            }) : _vm._e(), _vm._v(" "), ks === 'office' ? _c('input-select', {
              attrs: {
                "datas": typePlace.reduce(function (acc, tp) {
                  return [].concat(acc, [{
                    value: tp[0].toUpperCase() + tp.slice(1).toLowerCase()
                  }]);
                }, []),
                "name": ktp,
                "libelle": ktp,
                "value": (_vm.form.data.success.value[ks] || {})[ktp] || '',
                "error": true
              },
              on: {
                "input": function (newValue) {
                  _vm.displaySuccess(ks, ktp, newValue);
                },
                "loseFocus": function ($event) {
                  return _vm.saveDatas();
                }
              }
            }) : _vm._e()], 1);
          }), 0)];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }